import React from "react";
import { InstantSearch as ReactInstantSearch } from "react-instantsearch";

import { useAlgoliaSearchClient } from "../../../algolia/state/algoliaSearchClient";

import LoadingContext from "../LoadingContext/LoadingContext";

import InstantSearchConfigure from "./InstantSearchConfigure";

export default function InstantSearch({ indexName, configure, routing, initialUiState = {}, loaderSize, children }) {
	const [searchClient, loading, error] = useAlgoliaSearchClient();

	return (
		<LoadingContext loading={loading} error={error} loaderSize={loaderSize}>
			<ReactInstantSearch
				routing={routing}
				indexName={indexName}
				searchClient={searchClient}
				initialUiState={{
					[indexName]: initialUiState,
				}}
			>
				<InstantSearchConfigure {...configure} />

				{children}
			</ReactInstantSearch>
		</LoadingContext>
	);
}
